module.exports = __webpack_public_path__ + "img/envelope.a11ba8cd.svg";